const LoginStyles = theme => ({
  root: {
    flexGrow: 1,
    paddingTop: "2rem"
  },
  formBtn: {
    margin: "0.7em",
    float: "right"
  }
});

export default LoginStyles;
